import { ITag, TagPicker } from "@fluentui/react";
import React, { useContext } from "react";
import { ColumnOptionsContext } from "./ColumnOptions";
import { Column, TaxonomyFilter as TaxonomyFilterType } from "./types";

type Props = {
  column: Column;
};

export const TaxonomySelectFilter = ({ column }: Props) => {
  const filter = column.filter as TaxonomyFilterType;
  const { taxonomy, setFilter, t, id } = useContext(ColumnOptionsContext);

  const allOptions: ITag[] = (taxonomy[filter.taxonomyKey] || [])
    .filter((tax) => {
      if (filter.exclude) {
        return !filter.exclude.includes(tax.code);
      }
      return true;
    })
    .map((tax) => ({
      key: tax.id,
      name: filter.customOptionLabel
        ? filter.customOptionLabel(tax)
        : t(tax.code),
    }));

  const selectedItems: ITag[] = filter.value
    .map((vId) => allOptions.find((opt) => opt.key === vId))
    .filter(Boolean) as ITag[];

  const onResolveSuggestions = (filterText: string): ITag[] => {
    return allOptions.filter((option) => {
      const notSelected = !filter.value.includes(option.key as number);
      const matches =
        !filterText ||
        option.name.toLowerCase().includes(filterText.toLowerCase());
      return notSelected && matches;
    });
  };

  const onChange = (items?: ITag[]) => {
    setFilter(column.key, {
      ...filter,
      value: (items || []).map((i) => Number(i.key)),
    });
  };

  return (
    <TagPicker
      selectedItems={selectedItems}
      onResolveSuggestions={onResolveSuggestions}
      onChange={onChange}
      resolveDelay={150}
      inputProps={{
        id: id ? `${id}-taxonomySelect-input-${column.key}` : undefined,
        placeholder: column.placeholder ? t(column.placeholder) : undefined,
      }}
      pickerSuggestionsProps={{
        suggestionsHeaderText: "",
        noResultsFoundText: "",
      }}
    />
  );
};
